import { useState } from "react";

/** 一度成立した初回ロード完了状態を、同じマウント内では解除しない。 */
export function reduceCanvasInitialLoadLatch(completed: boolean, ready: boolean): boolean {
  return completed || ready;
}

/** キャンバスの初回ロードが一度完了したことを保持する。 */
export function useCanvasInitialLoadLatch(ready: boolean): boolean {
  const [completed, setCompleted] = useState(false);
  const next = reduceCanvasInitialLoadLatch(completed, ready);
  if (next !== completed) {
    setCompleted(next);
  }
  return next;
}

/** 初回ロード完了状態とエラー状態から、ワークスペースとオーバーレイの表示を決める。 */
export function resolveCanvasLoadPresentation(input: {
  readonly initialLoadCompleted: boolean;
  readonly error: boolean;
}): { readonly showWorkspace: boolean; readonly showOverlay: boolean } {
  return {
    showWorkspace: input.initialLoadCompleted && !input.error,
    showOverlay: !input.initialLoadCompleted || input.error,
  };
}
